import {connect} from "react-redux"
import {createSelector} from "reselect"
import State from "../../../models/State"
import {FilterFacet} from "../../../models/Filter"
import filterThroughFacets from "../../../utils/filterThroughFacets"
import {selectRealm} from "../../../ducks/request"
import {setFreeTextFilterSearch} from "../../../ducks/search"
import {BRAND} from "../../../config/constants"

const selectSelectedFilter = (state: State) => state.tabbedFilters.selectedFilter
const selectTabbedFilters = (state: State) => state.tabbedFilters.filters
const selectFreeTextFilterSearch = (state: State) => state.search.freeTextFilterSearch

const selectFilteredFacets = (currentRealm: string) =>
    createSelector(
        [selectSelectedFilter, selectTabbedFilters, selectFreeTextFilterSearch],
        (selectedFilter, filters, freeTextFilterSearch) => {
            const searchText =
                selectedFilter && freeTextFilterSearch[selectedFilter] ? freeTextFilterSearch[selectedFilter] : ""
            const {facets} = filters[selectedFilter || ""] as FilterFacet

            const filteredFacets = filterThroughFacets(searchText, facets, selectedFilter || "", currentRealm)
            return filteredFacets
        },
    )
const mapStateToProps = (state: State) => {
    const {showRealmInTopFiveBrands, freeTextFilterSearch, freeTextFiltersList, compositeFiltersList} = state.search
    const {selectedFilter} = state.tabbedFilters
    const currentRealm = selectedFilter === BRAND && showRealmInTopFiveBrands ? selectRealm(state) : ""

    const filterFacets = selectFilteredFacets(currentRealm)(state)

    const {text} = state

    return {
        freeTextFilterSearch,
        filterFacets,
        text,
        freeTextFiltersList,
        compositeFiltersList,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    setFreeTextFilterSearch: (e: React.SyntheticEvent, filterName: string) => {
        const {value} = e.target as HTMLInputElement
        dispatch(setFreeTextFilterSearch({filterName, value}))
    },
    clearFreeTextSearchForFilter: (filterName: string) => {
        dispatch(setFreeTextFilterSearch({value: "", filterName}))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
